// Trabajo de campo sin señal (copia local de la app, inspecciones sin ente, indicador global).
// Apagado por decisión de Omar (10/10): la sesión debe ser independiente por pestaña
// (sessionStorage) y sin señal se captura en hoja y se pasa al sistema en la oficina.
// Desde el 17/10 también apaga el borrador por ente de Evaluación de Inspección (IndexedDB) y su
// sincronización/avisos de conflicto: la evaluación se guarda solo contra el servidor. Los
// borradores que ya existan en el dispositivo no se borran; solo se ignoran.
export const OFFLINE_FIELD_MODE = false;
